/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Paste_TextInputs */

const en_mobile_paste_text = /** @type {(inputs: Mobile_Paste_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste text`)
};

const es_mobile_paste_text = /** @type {(inputs: Mobile_Paste_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar texto`)
};

/**
* | output |
* | --- |
* | "Paste text" |
*
* @param {Mobile_Paste_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_paste_text = /** @type {((inputs?: Mobile_Paste_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Paste_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_paste_text(inputs)
	return en_mobile_paste_text(inputs)
});